import { render, staticRenderFns } from "./LgFormDate.vue?vue&type=template&id=3d3ccf45&scoped=true"
import script from "./LgFormDate.vue?vue&type=script&lang=js"
export * from "./LgFormDate.vue?vue&type=script&lang=js"
import style0 from "./LgFormDate.vue?vue&type=style&index=0&id=3d3ccf45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3ccf45",
  null
  
)

export default component.exports